import type { BrandConfig } from './types'

const id = 'teg'
const assetBase = `/brands/${id}`

export const tegBrand: BrandConfig = {
    id,
    name: 'Texas Energy Group',
    nameUpper: 'TEXAS ENERGY GROUP',
    logos: {
        header: {
            src: `${assetBase}/logo-header.webp`,
            alt: 'TEXAS ENERGY GROUP',
            height: 70,
        },
        footer: {
            src: `${assetBase}/logo-footer.png`,
            alt: 'TEXAS ENERGY GROUP',
            width: 300,
            height: 123,
        },
    },
    favicons: {
        icon32: `${assetBase}/favicon-32.webp`,
        icon192: `${assetBase}/favicon-192.webp`,
        apple180: `${assetBase}/favicon-180.jpg`,
        apple270: `${assetBase}/favicon-270.jpg`,
    },
    seo: {
        defaultTitle: 'Texas Energy Group - TEXAS ENERGY GROUP',
        themeColor: '#000000',
    },
}
